module.exports = __webpack_public_path__ + "static/media/termsImg_2.55367288.jpg";